import type { ConnectionStatus } from '../../services/connection.service';

export function connectionIconName(status: ConnectionStatus | null): string {
  switch (status) {
    case 'offline':
      return 'cloud-offline-outline';
    case 'slow':
      return 'wifi-outline';
    case 'fast':
      return 'wifi-sharp';
    default:
      return 'wifi-sharp';
  }
}

export async function pingEndpoint(url: string, timeout: number = 30000): Promise<number> {
  const testUrl = `${url}?ping=${Date.now()}`;
  const startTime = performance.now();

  try {
    const response = await fetch(testUrl, {
      method: 'HEAD',
      cache: 'no-store',
      credentials: 'same-origin',
      signal: AbortSignal.timeout(timeout),
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    return performance.now() - startTime;
  } catch (error) {
    throw new Error(`Ping failed: ${error instanceof Error ? error.message : 'Unknown error'}`);
  }
}
